module.exports = __webpack_public_path__ + "img/motivation.581f5c93.svg";